import Keycloak from 'keycloak-js';
import type { KeycloakInitOptions, KeycloakLoginOptions, KeycloakLogoutOptions } from 'keycloak-js';
import { env } from '@app/config/env';

/**
 * Keycloak singleton instance.
 */
export const keycloak = new Keycloak({
  url: env.keycloak.url,
  realm: env.keycloak.realm,
  clientId: env.keycloak.clientId,
});

let initPromise: Promise<boolean> | null = null;

/**
 * Initialize Keycloak authentication.
 * Uses `login-required` to redirect to Keycloak login if not authenticated.
 */
export const initKeycloak = (options?: KeycloakInitOptions): Promise<boolean> => {
  if (!initPromise) {
    initPromise = keycloak.init({
      onLoad: 'login-required',
      pkceMethod: 'S256',
      ...options,
    });
  }
  return initPromise;
};

export const keycloakLogin = (options?: KeycloakLoginOptions) => keycloak.login(options);

export const keycloakLogout = (options?: KeycloakLogoutOptions) => keycloak.logout(options);

export const refreshKeycloakToken = async (minValiditySeconds = 30) => {
  const refreshed = await keycloak.updateToken(minValiditySeconds);
  return {
    refreshed,
    token: keycloak.token ?? null,
    refreshToken: keycloak.refreshToken ?? null,
    tokenParsed: keycloak.tokenParsed ?? null,
  };
};
